<template>
  <div class="solution-us">
    <h3 class="title">综合解决方案</h3>
    <div class="bar">
      <div class="circular"></div>
    </div>
    <p class="subheading">
      依据企业自身特点及业务需求，提供信息化设计、系统研发、系统集成、网络安全、物联网接入、物联网应用、云端服务对接、公有云/私有云部署与运维等企业信息化相关的综合服务。
    </p>
    <div class="solution-main">
      <div class="solution">
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="icon-img" name="cog" />
            </div>
            <div class="display">
              <h3>信息技术咨询</h3>
              <p class="detailed">
                IT技术顾问服务，包括：IT战略规划及实施计划、IT系统设计、IT管理、IT工程监理等咨询服务。
              </p>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="icon-img" name="database" />
            </div>
            <div class="display">
              <h3>信息技术运维</h3>
              <p class="detailed">
                对IT运行环境（如基础环境、硬件和软件环境、网络环境等）、IT业务系统等提供综合服务。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="solution">
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon bg">
              <v-icon class="icon-img" name="sitemap" />
            </div>
            <div class="display">
              <h3>信息系统</h3>
              <p class="detailed">
                软件运营服务、容灾服务、能源管理服务平台、IOT管理系统、项目管理系统、充电站管理系统、充电管理服务平台、电池管理系统等。
              </p>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon bg">
              <v-icon class="icon-img" name="share-alt" />
            </div>
            <div class="display">
              <h3>系统集成</h3>
              <p class="detailed">
                将企业多个应用系统进行集成融合。包括用户、信息、终端系统等。将各个分离的设备、功能和信息等集成到相互关联的、统一和协调的系统之中。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="solution">
        <div class="solution-content">
          <div class="grid-content">
            <div class="icon bg2">
              <v-icon class="icon-img" name="recycle" />
            </div>
            <div class="display">
              <h3>数据处理</h3>
              <p class="detailed">
                数据分析、整理、计算、编辑、数据恢复等加工和处理。
              </p>
            </div>
          </div>
        </div>
        <div class="solution-content">
          <div class="grid-content clearance">
            <div class="icon bg2">
              <v-icon class="icon-img" name="desktop" />
            </div>
            <div class="display">
              <h3>设计开发</h3>
              <p class="detailed">
                软件调研、设计、研发、测试等服务
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "solution",
};
</script>

<style lang="scss" scoped>
.solution-us {
  padding-top: 70px;
  padding-bottom: 70px;
  background: #f9f6f6;

  @media (max-width: 768px) {
    .subheading {
      text-align: left;
      text-indent: 25px;
    }
  }
}

.title {
  font-size: 22px;
  margin: 0px;
}

.bar {
  height: 4px;
  width: 90px;
  background: #cdf1d8;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #44ce6f;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/

    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 50px;
  color: #6084a4;
  line-height: 1.9;
  padding: 0 15px;
}

.solution-main {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 605px) {
    width: auto;
    .solution {
      display: block;
    }
  }

  // @media (min-width: 576px) {
  //   max-width: 540px;
  // }

  @media (max-width: 768px) {
    padding: 0;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    max-width: 680px;

    .grid-content {
      padding-left: 20px;

      .icon {
        position: relative;
        left: 0;
        top: 0;
        margin-bottom: 25px;
      }

      .display {
        margin-left: 0px;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.solution {
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.grid-content {
  position: relative;
  border-radius: 5px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  background: #ffffff;
  text-align: left;
  margin-bottom: 30px;
  padding-left: 95px;
  padding-top: 30px;
  padding-right: 20px;
  padding-bottom: 30px;

  h3 {
    transition: 0.5s;
    margin-top: 0px;
    margin-bottom: 17px;
    line-height: 1.4;
    z-index: 999;
    font-size: 16px;
    font-weight: 600;
    color: #0e314c;
  }

  p {
    margin-bottom: 0px;
    transition: 0.9s;
    font-size: 14px;
    color: #6084a4;
    line-height: 1.9;
    letter-spacing: 1px;
  }

  &:hover {
    box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
    transform: translateY(-10px);

    .icon {
      background: #44ce6f;
      & > .icon-img {
        color: #ffffff;
      }
    }

    .bg {
      background: #c679e3;
      & > .icon-img {
        color: #ffffff;
      }
    }

    .bg2 {
      background: #eb6b3d;
      & > .icon-img {
        color: #ffffff;
      }
    }

    &::before {
      width: 50%;
      opacity: 1;
    }

    &::after {
      width: 50%;
      right: 0;
      opacity: 1;
    }
  }

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0px;
    height: 4px;
    background: #44ce6f;
    transition: 0.5s;
    opacity: 0;
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 0;
    height: 4px;
    background: #44ce6f;
    transition: 0.5s;
    opacity: 0;
  }
}

.clearance {
  margin-bottom: 0px;
}

.icon {
  position: absolute;
  text-align: center;
  width: 55px;
  height: 55px;
  line-height: 62px;
  background: #cdf1d8;
  border-radius: 50%;
  color: #44ce6f;
  left: 20px;
  top: 30px;
  -webkit-transition: 0.5s;
  transition: 0.5s;

  & > .icon-img {
    width: 20px;
    height: 20px;
  }
}

.bg {
  color: #c679e3;
  background: #edc3fc;
  & > .icon-img {
    width: 20px;
    height: 20px;
  }
}

.bg2 {
  color: #eb6b3d;
  background: rgba(235, 107, 61, 0.3);
  & > .icon-img {
    width: 20px;
    height: 20px;
  }
}

.phone {
  transform: rotateY(180deg);
}

.display {
  margin-left: 20px;
}
</style>